// extracted by mini-css-extract-plugin
export var childrenContent = "b4_gF";
export var content = "b4_V";
export var titleContent = "b4_gG";
export var titleContentLabel = "b4_gH";